import {
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import {
  CapitalIncreaseThroughBonusIssue,
  CapitalIncreaseThroughBonusIssueForm,
  toBonusIssueType,
} from "./capitalIncreaseThroughBonusIssueDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<CapitalIncreaseThroughBonusIssue>,
  data?: CapitalIncreaseThroughBonusIssue,
): CapitalIncreaseThroughBonusIssueForm {
  return new CapitalIncreaseThroughBonusIssueForm(dispatch, context, data);
}

export function applyForm(
  form: CapitalIncreaseThroughBonusIssueForm,
): CapitalIncreaseThroughBonusIssue {
  return {
    type: DecisionType.capitalIncreaseThroughBonusIssue,
    resolutionIsBasedOnIntermediateBalanceSheet:
      form.resolutionIsBasedOnIntermediateBalanceSheetModel.value ?? false,
    intermediateBalanceSheetDate: form.intermediateBalanceSheetDateModel.validatedValue,
    properties: toBonusIssueType(form.properties),
    articleOfAssociationNumber: form.articleOfAssociationNumber.selected,
  };
}

export function validate(form: CapitalIncreaseThroughBonusIssueForm) {
  return form.validate();
}

export function isValid(form: CapitalIncreaseThroughBonusIssueForm) {
  return form.isValid;
}

export const capitalIncreaseThroughBonusIssueHandler: DecisionTypeHandler<
  DecisionType.capitalIncreaseThroughBonusIssue,
  CapitalIncreaseThroughBonusIssue,
  CapitalIncreaseThroughBonusIssueForm
> = {
  type: DecisionType.capitalIncreaseThroughBonusIssue,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent(form, event) {
    form.handleEvent(event);
  },
};
